import request from '@/utils/request'

/**
 * 删除家政服务
 * @param {Object} data 请求参数
 * @returns {Promise} Promise对象
 */
export function deleteAdminServ(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housekeepingServ.deleteAdminServ',
      method: 'post',
      data,
      emulateJSON: true
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}